import React, { useEffect, useMemo, useState } from 'react';
import t from '@jetshop/intl';
import { styled } from 'linaria/react';import { ReactComponent as Carrot } from '../../../svg/Carrot.svg';
import { StepHeader } from './StepHeader';
import { StepHeaderTextDescription } from '../Elements/StepHeaderTextDescription';
import { Item } from '../Elements/Item';
import LoadingPage from '../../LoadingPage';
import Products3DConfig from '../Config/products.config';
import { useQuery } from 'react-apollo';
import Product3D from '../Data/Product3D.gql';
import GetProduct from '../Data/GetProduct';
import Articles3DConfig from '../Config/articles.config';

const StyledWrapperStepTwo = styled('div')`
  display: flex;
  flex-direction: column;
  margin: 0 auto 4rem;
  justify-content: space-between;
  width: 100%;
`
const StepHeaderText = styled('div')`
  font-weight: bold;
  font-size: 18px;

  @media screen and (max-width: 800px) {
    font-size: 16px;
    width: 100%;
    margin: 0 40px 0 0;
  }
`
const StepHeaderButton = styled('div')`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  border-radius: 50px;
  margin: 0 auto;
  background: #911827;
  width: 100px;
  height: 35px;
  position: absolute;
  right: 0;
  cursor: pointer;
  display: ${({ active }) => (active ? 'flex' : 'none')};
  @media screen and (max-width: 800px) {
    top: 50%;
    transform: translateY(-50%);
  }
`
const StepHeaderButtonPrev = styled('div')`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  border-radius: 50px;
  margin: 0 auto;
  background: #911827;
  width: 35px;
  height: 35px;
  position: absolute;
  left: 0;
  cursor: pointer;
  display: flex;
  @media screen and (max-width: 800px) {
    top: 50%;
    transform: translateY(-50%);
  }
  
`
const StepHeaderButtonText = styled('p')`
  margin: 5px 0;
  color: #fff;
`
const SvgWrapper = styled('div')`
  width: 15px;
  transition: transform 0.3s;

  svg {
    use {
      fill: #fff;
    }
  }
  transform: rotate(-90deg);
`;
const SvgWrapperReverse = styled('div')`
  width: 15px;
  transition: transform 0.3s;

  svg {
    use {
      fill: #fff;
    }
  }
  transform: rotate(90deg);
`;
const ProductWrapper = styled('div')`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
  @media screen and (max-width: 800px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
  }
  @media screen and (max-width: 600px) {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
  }
`


export const ProductStep = ({ currentStep, setCurrentStep, activeProduct, setActiveProduct, activeCategory, setActiveCategory, activeTextileIndex, setActiveTextileIndex, activeLeg, setActiveLeg }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  useEffect(() => {
    sessionStorage.removeItem('mobelmastarna_3d_textiles');
    sessionStorage.removeItem('mobelmastarna_3d_legs');
  }, []);

  // Filter products by activeCategory
  const products = useMemo(() =>
      Products3DConfig.filter(product => product.category.split(',').includes(activeCategory))
        .map(product => {
          try {
            if (product.useDifferentImage) {
              product.images = [{ url: require(`../assets/products/${product.useDifferentImage}.jpg`), alt: product.name }];
            } else {
              product.images = [{ url: require(`../assets/products/${product.articleNumbers[0]}.jpg`), alt: product.name }];
            }
          } catch {
            product.images = [{ url: require('../../../svg/Logo.svg').default, alt: product.name }];
          }
          return product;
        }),
    [activeCategory]
  );


  // Render loading until client-only data is ready
  if (typeof window === 'undefined') {
    return <StyledWrapperStepTwo id="3d-wrapper">
      <StepHeader>
        <div>
          <StepHeaderButtonPrev
            active={1}
            onClick={() => {
              setCurrentStep((i) => i - 1)
              window.sessionStorage.setItem('lastStep', currentStep - 1);
            }}
          >
            <SvgWrapperReverse>
              <Carrot />
            </SvgWrapperReverse>
          </StepHeaderButtonPrev>
        </div>
        <StepHeaderText>{t('Soffa')}<StepHeaderTextDescription>2/5</StepHeaderTextDescription></StepHeaderText>
        <div>
          <StepHeaderButton
            active={activeIndex !== null ? 1 : 0}
            onClick={() => {
              setCurrentStep((i) => i + 1)
              setActiveProduct(products[activeIndex])
              window.sessionStorage.setItem('lastStep', currentStep);
            }}
          >
            <StepHeaderButtonText>{t('Nästa')}</StepHeaderButtonText>
            <SvgWrapper>
              <Carrot />
            </SvgWrapper>
          </StepHeaderButton>
        </div>
      </StepHeader>
      <LoadingPage style={{height: '100px'}} />
    </StyledWrapperStepTwo>
  }

  return (
    <>
      <StyledWrapperStepTwo id="3d-wrapper">
        <StepHeader>
          <div>
            <StepHeaderButtonPrev
              active={1}
              onClick={() => {
                setCurrentStep((i) => i - 1)
                window.sessionStorage.setItem('lastStep', currentStep - 1);
              }}
            >
              <SvgWrapperReverse>
                <Carrot />
              </SvgWrapperReverse>
            </StepHeaderButtonPrev>
          </div>
          <StepHeaderText>{t('Soffa')}<StepHeaderTextDescription>2/5</StepHeaderTextDescription></StepHeaderText>
          <div>
            <StepHeaderButton
              active={activeIndex !== null ? 1 : 0}
              onClick={() => {
                setCurrentStep((i) => i + 1)
                setActiveProduct(products[activeIndex])
                window.sessionStorage.setItem('lastStep', currentStep);
              }}
            >
              <StepHeaderButtonText>{t('Nästa')}</StepHeaderButtonText>
              <SvgWrapper>
                <Carrot />
              </SvgWrapper>
            </StepHeaderButton>
          </div>
        </StepHeader>
        <ProductWrapper>
          {products.map((product, index) => (
            <Item
              key={index}
              item={product}
              onClick={() => {
                if (index === activeIndex) {
                  setActiveIndex(null);
                } else {
                  setActiveIndex(index);
                  setActiveProduct(products[index])
                  window.sessionStorage.setItem('lastStep', currentStep);
                  setCurrentStep((i) => i + 1)
                }
              }}
              isActive={activeIndex === index}
            />
          ))}
        </ProductWrapper>
      </StyledWrapperStepTwo>
    </>
  );
}